import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { updateCustomApplicationRequest as ticketUpdate } from '../state';
import { updateCustomApplicationRequest as recurringTaskUpdate } from '../../recurringTasks/state';
import { CustomApplicationRequestView } from '../../../types/shared/accessRequestTypes';
import { EditorMode } from '../types/editorTypes';

/**
 * Custom hook that abstracts Redux state selection and dispatch for
 * Custom Application editors. Returns the current request data and
 * a mode-aware update function.
 */
export const useCustomApplicationEditor = (mode: EditorMode) => {
  const dispatch = useAppDispatch();

  const request = useAppSelector(state =>
    mode === 'ticket'
      ? state.ticket.currentTicket?.customApplicationRequest
      : state.recurringTask.currentRecurringTask?.customApplicationRequest
  );

  const updateRequest = useCallback(
    (update: Partial<CustomApplicationRequestView>) => {
      if (mode === 'ticket') {
        dispatch(ticketUpdate(update));
      } else {
        dispatch(recurringTaskUpdate(update));
      }
    },
    [dispatch, mode]
  );

  return { request, updateRequest };
};
